import React, { createContext, useContext } from "react";
import { ProductLightbox } from "./ProductLightbox.jsx";
import { useProductLightbox } from "./use-product-lightbox";
import { useSwitchAnchorOnProductChange } from "./use-switch-anchor-on-product-change.js";
import { useWebshare } from "../utils/web-share.js";

const ProductLightboxVisibilityControlsContext = createContext(null);

export const useProductLightboxControls = () => {
	const context = useContext(ProductLightboxVisibilityControlsContext);

	if (context === null) {
		console.error(
			"useProductLightboxContext must be used within a ProductLightboxContextProvider"
		);
		return null;
	}

	return context;
};

export const ProductLightboxProvider = ({ children, allProducts }) => {
	const { switchAnchorOnProductChange } = useSwitchAnchorOnProductChange({
		products: allProducts,
	});

	const {
		controls,
		currentProductIndex,
		visible,
		hasNext,
		hasPrevious,
		moveNext,
		movePrevious,
	} = useProductLightbox({
		products: allProducts,
		onProductChange: switchAnchorOnProductChange,
	});

	const { hideProductLightbox } = controls;

	const { webshareLoading, share } = useWebshare();

	return (
		<>
			<ProductLightboxVisibilityControlsContext.Provider value={controls}>
				{children}
			</ProductLightboxVisibilityControlsContext.Provider>

			{visible ? (
				<ProductLightbox
					products={allProducts}
					currentProductIndex={currentProductIndex}
					onClose={hideProductLightbox}
					hasNext={hasNext}
					hasPrevious={hasPrevious}
					moveNext={moveNext}
					movePrevious={movePrevious}
					lightboxControls={controls}
					visible={visible}
					share={share}
					webshareLoading={webshareLoading}
				/>
			) : null}
		</>
	);
};
